export default function HeadphoneIcon({
  color = '#9B9DA2',
  width = '19',
  height = '19',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.40935 17.971C2.55685 17.971 0.989352 16.4034 0.989352 14.5509V9.67426C0.949769 7.36263 1.80477 5.18555 3.40394 3.55471C5.0031 1.9318 7.14852 1.0293 9.46018 1.0293C14.1785 1.0293 18.0102 4.86888 18.0102 9.57926V14.4559C18.0102 16.3401 16.4743 17.8759 14.5902 17.8759C12.7377 17.8759 11.1702 16.3084 11.1702 14.4559V12.2313C11.1702 11.0834 12.0727 10.1809 13.2206 10.1809C14.3685 10.1809 15.271 11.0834 15.271 12.2313V14.6301C15.271 14.9547 15.0018 15.2238 14.6773 15.2238C14.3527 15.2238 14.0835 14.9547 14.0835 14.6301V12.2313C14.0835 11.693 13.6481 11.3684 13.2206 11.3684C12.6823 11.3684 12.3577 11.8038 12.3577 12.2313V14.4559C12.3577 15.6673 13.3789 16.6884 14.5902 16.6884C15.8014 16.6884 16.8227 15.6673 16.8227 14.4559V9.57926C16.8227 5.51805 13.5214 2.2168 9.46018 2.2168C7.4731 2.2168 5.62852 2.98471 4.25102 4.38596C2.87352 5.78721 2.13727 7.66346 2.17685 9.65842V14.5509C2.17685 15.7622 3.1981 16.7835 4.40935 16.7835C5.6206 16.7835 6.64185 15.7622 6.64185 14.5509V12.3263C6.64185 11.788 6.20644 11.4634 5.77893 11.4634C5.2406 11.4634 4.91602 11.8988 4.91602 12.3263V14.638C4.91602 14.9626 4.64685 15.2318 4.32227 15.2318C3.99769 15.2318 3.72852 14.9626 3.72852 14.638V12.3263C3.72852 11.1784 4.63102 10.2759 5.77893 10.2759C6.92685 10.2759 7.82935 11.1784 7.82935 12.3263V14.5509C7.82935 16.4034 6.26185 17.971 4.40935 17.971Z'
        fill={color}
      />
    </svg>
  );
}
